<owc-card class="searchBar">
  <dl-audit-trail-search></dl-audit-trail-search>
</owc-card>
<owc-table style="height: 100vh;">
  <owc-table-header sticky>
    <owc-table-header-cell>Timestamp</owc-table-header-cell>
    <owc-table-header-cell>User
    </owc-table-header-cell>
    <owc-table-header-cell>Role</owc-table-header-cell>
    <owc-table-header-cell>Property Name
    </owc-table-header-cell>
    <owc-table-header-cell>Previous Value</owc-table-header-cell>
    <owc-table-header-cell>New Value</owc-table-header-cell>
  </owc-table-header>

  <owc-table-body>
    @if(pagedData?.length > 0){
    @for (element of pagedData; track element) {
    <owc-table-row locked>

      <owc-table-simple-cell>
        <div class="truncate-text">
          <span class="wrap">
            {{appUtils.formatDateWithTimeUptoSec(element.timestamp)}}
          </span>
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell>
        <div class="truncate-text">
          {{element.modifiedBy}}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell>
        <div class="truncate-text">
          {{element.role}}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell>
        <div class="truncate-text">
          {{element.propertyName}}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell>
        <div *ngIf="isString(element.oldValue); else noStringOldValue" class="truncate-text" [title]="element.oldValue">
          <span class="wrap">
            {{element.oldValue}}
          </span>
        </div>
        <ng-template #noStringOldValue>
          <owc-chip [title]="toJSON(element.oldValue)"
            class="list-source-chip truncate-text" oneChip oneChipAppearance="outline">
            Object
          </owc-chip>
        </ng-template>
      </owc-table-simple-cell>
      <owc-table-simple-cell>
        <div *ngIf="isString(element.newValue); else noStringNewValue" class="truncate-text" [title]="element.newValue">
          <span class="wrap">
            {{element.newValue}}
          </span>
        </div>
        <ng-template #noStringNewValue>
          <owc-chip [title]="toJSON(element.newValue)"
            class="list-source-chip truncate-text" oneChip oneChipAppearance="outline">
            Object
          </owc-chip>
        </ng-template>
      </owc-table-simple-cell>


    </owc-table-row>
    }
    }
  </owc-table-body>
</owc-table>
<!-- Standardized Pagination -->
<div class="simple-pagination" *ngIf="totalCount > 0">
  <div class="pagination-left">
    <owc-button (click)="closeClicked()">Close</owc-button>
    <span class="items-per-page-label">Items per page:</span>
    <select 
      class="page-size-dropdown"
      [value]="pageSize" 
      (change)="onPageSizeChange($event)">
      <option *ngFor="let size of pageSizeOptions" [value]="size">
        {{ size }}
      </option>
    </select>
  </div>
  
  <div class="pagination-center">
    <span class="pagination-info">{{ startIndex }} - {{ endIndex }} of {{ totalCount }}</span>
  </div>
  
  <div class="pagination-right">
    <button 
      class="nav-button" 
      [disabled]="currentPage === 0"
      (click)="goToFirstPage()"
      title="First page">
      &#8810;
    </button>
    <button 
      class="nav-button" 
      [disabled]="currentPage === 0"
      (click)="goToPreviousPage()"
      title="Previous page">
      &#8249;
    </button>
    <button 
      class="nav-button" 
      [disabled]="currentPage >= totalPages - 1"
      (click)="goToNextPage()"
      title="Next page">
      &#8250;
    </button>
    <button 
      class="nav-button" 
      [disabled]="currentPage >= totalPages - 1"
      (click)="goToLastPage()"
      title="Last page">
      &#8811;
    </button>
  </div>
</div>

<!-- Fallback for when no data -->
<div *ngIf="totalCount === 0" class="no-data-pagination">
  <div class="pagination-left">
    <owc-button (click)="closeClicked()">Close</owc-button>
  </div>
</div>